// src/components/studio/steps/Step2Letter.tsx
import { motion, AnimatePresence } from "framer-motion";

interface Step2LetterProps {
  customization: any;
  setCustomization: (c: any) => void;
  validation: any;
}

export default function Step2Letter({
  customization,
  setCustomization,
  validation,
}: Step2LetterProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col h-full space-y-2 md:space-y-6"
    >
      <div className="text-center">
        <p className="text-[9px] uppercase tracking-[0.5em] text-white/30">
          Speak from the heart...
        </p>
      </div>

      <div
        className="relative flex-1 p-8 md:p-12 rounded-xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.5)] overflow-hidden"
        style={{
          background: "#f0eeecff",
          border: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none mix-blend-multiply bg-[url('https://www.transparenttextures.com/patterns/paper-fibers.png')]" />

        <div
          className="absolute inset-0 pointer-events-none opacity-[0.05]"
          style={{
            backgroundImage: `linear-gradient(#000 1px, transparent 1px)`,
            backgroundSize: "100% 32px",
            marginTop: "45px",
          }}
        />

        <textarea
          value={customization.message}
          onChange={(e) =>
            setCustomization({
              ...customization,
              message: e.target.value,
            })
          }
          placeholder="Speak from the heart..."
          rows={12}
          className="relative outline-none z-10 w-full h-full bg-transparent border-none focus:ring-0 text-black/80 font-serif italic text-lg md:text-xl leading-[32px] resize-none placeholder:text-black/10"
          style={{
            fontFamily: "'Playfair Display', serif",
            scrollbarWidth: "none",
          }}
        />

        <div className="absolute bottom-6 right-8 flex items-center gap-3">
          <span
            className={`text-[9px] font-bold uppercase tracking-widest transition-colors duration-500 ${
              validation.isStep2Valid ? "text-primary" : "text-black/20"
            }`}
          >
            {customization.message?.length || 0} Characters
          </span>
          <div
            className={`w-2 h-2 rounded-full transition-all duration-500 ${
              validation.isStep2Valid ? "bg-primary shadow-[0_0_10px_#E11D48]" : "bg-black/10"
            }`}
          />
        </div>
      </div>

      <AnimatePresence>
        {!validation.isStep2Valid && customization.message?.length > 0 && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="text-center text-[9px] uppercase tracking-[0.2em] text-primary/60 italic"
          >
            Pour a little more heart into it (minimum 10 characters)
          </motion.p>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
